import React from 'react';
import dotenv from 'dotenv';
import { FormattedMessage } from 'react-intl';
import translationsComponents from '../view/containers/translationsComponents';

import one from '../themes/default/assets/one.svg';
import two from '../themes/default/assets/two.svg';
import two_uk from '../themes/default/assets/two_uk.svg';
import two_ics from '../themes/default/assets/two_ics.svg';
import three from '../themes/default/assets/three.svg';
import four from '../themes/default/assets/outline_Default_Left.svg';
import five from '../themes/default/assets/five.svg';
import six from '../themes/default/assets/six.svg';
import seven from '../themes/default/assets/outline_Default_Right.svg';
import eight from '../themes/default/assets/eight.svg';
import nine from '../themes/default/assets/nine.svg';
import ten from '../themes/default/assets/ten.svg';
import eleven from '../themes/default/assets/eleven.svg';
import twelve from '../themes/default/assets/twelve.svg';
import thirteen from '../themes/default/assets/thirteen.svg';
import fifteen from '../themes/default/assets/outline_Rear_Tire.svg';
import rhd_2 from '../themes/default/assets/rhd_2.png';
import rhd_6 from '../themes/default/assets/rhd_6.png';
import rhd_9 from '../themes/default/assets/rhd_9.png';
import amz_10 from '../themes/default/assets/amz_FRONT_LEFT.svg';
import amz_11 from '../themes/default/assets/amz_FRONT_RIGHT.svg';
import amz_12 from '../themes/default/assets/amz_REAR_RIGHT.svg';
import amz_13 from '../themes/default/assets/amz_REAR_LEFT.svg';

import amz_04 from '../themes/default/assets/amz_LEFT_VIEW_04.svg';
import amz_05 from '../themes/default/assets/amz_FRONT_VIEW_05.svg';
import amz_08 from '../themes/default/assets/amz_REAR_VIEW_08.svg';
import amz_07 from '../themes/default/assets/amz_RIGHT_VIEW_07.svg';

import no_defined_outline from '../themes/default/assets/no_defined_outline.svg';
import search from '../themes/default/assets/search.png';

import translationsUI from '~/view/ui/translationUI';

// Require ENV
dotenv.config();

//TESING PATH
export const TESTING_PATH = '/pave-testing';

// ROUTER CONFIG URL

export const APP_PATH = '/';
export const HOME_PATH = 'home';
export const RESULT_PATH = 'result';
export const PREVIEW_PATH = 'preview=TRUE';
export const NATIVE_PATH = 'native-gallery';
export const SESSIONID_PATH = '/:sessionID';
export const REPORT_FINAL_PATH = 'result/report';
export const DISCLOSURE_PATH = 'result/disclosures';
export const REPORT_DAMAGE_PATH = 'result/reportdamages';
export const ANNOUNCEMENT_PATH = 'result/announcements';
export const REPORTADD_IMAGES_PATH = 'result/addimages';
export const REPORTADD_DAMAGES_PATH = 'result/adddamages';
export const BMW_DISCLOSURE_PATH = 'result/bmw-disclosures';
export const INSPECTION_RESULT_PATH = 'result/inspection-result';
export const FORMS_PATH = 'result/forms';

// ENV

export const APP_ENV = process.env.REACT_APP_APP_ENV;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const NOTIFY_URL = process.env.REACT_APP_NOTIFY_URL;
export const BASE_URL_V1 = process.env.REACT_APP_BASE_URL_V1;
export const DAMAGES_BMW = process.env.REACT_APP_DAMAGES_BMW;
export const NOTIFY_TOKEN = process.env.REACT_APP_NOTIFY_TOKEN;
export const APP_ENV_BETA = process.env.REACT_APP_APP_ENV_BETA;
export const AGENT_BASE_URL = process.env.REACT_APP_AGENT_BASE_URL;
export const REACT_APP_REPORT_URL = process.env.REACT_APP_REPORT_URL;
export const BASE_DAMAGES_TIRES = process.env.REACT_APP_DAMAGES_TIRES;
export const CANVAS_RESOLUTION = process.env.REACT_APP_CANVAS_RESOLUTION;

//FOR LOCALIZING
export const PAVE_LOCALIZATION = process.env.REACT_APP_PAVE_LOCALIZATION;

// FOR PAVE PASS

export const PAVE_PASS_API_KEY = process.env.REACT_APP_PAVE_PASS_KEY;
export const PAVE_PASS_BASE_URL = process.env.REACT_APP_PAVE_PASS_BASE_URL;

export const IMG_URL_UPLOAD = process.env.REACT_APP_IMG_URL_UPLOAD;
export const IMG_URL_UPLOAD_USER = process.env.REACT_APP_IMG_URL_UPLOAD_USER;
export const GET_SESSION_KEY_URL = process.env.REACT_APP_GET_SESSION_KEY_URL;
export const GET_SESSION_KEY_LICENSE =
  process.env.REACT_APP_GET_SESSION_KEY_LICENSE;
export const AGENT_TOKEN = process.env.REACT_APP_AGENT_TOKEN;
export const CONSOLE_DEBUG = process.env.REACT_APP_CONSOLE_DEBUG || 0;
export const EVENT_TRACKER = process.env.REACT_APP_EVENT_TRACKER || 1;
export const SESSION_CHECK_TIMER = process.env.SESSION_CHECK_TIMER || 12000;
export const PAVE_LOCATION_API = process.env.REACT_APP_PAVE_LOCATION_API;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const REACT_APP_CHECKING_VERSION =
  process.env.REACT_APP_CHECKING_VERSION;
export const APP_VERSION = process.env.REACT_APP_VERSION;

export const REACT_APP_PAVE_DASHBOARD = process.env.REACT_APP_PAVE_DASHBOARD;

export const REACT_APP_PAVE_VEHICLES_API =
  process.env.REACT_APP_PAVE_VEHICLES_API;

export const OPEN_API = process.env.REACT_APP_OPENAPI_ROOT;
export const PAVE_FORMS_API = process.env.REACT_APP_PAVE_FORMS;

export const REACT_APP_PAVE_CAGES_CDN = process.env.REACT_APP_PAVE_CAGES_CDN;

export const PAVE_URL_PATH = 'https://pave.ai/';

// export const PAVE_URL_NONE_REPORT_PATH = ' https://paveinspect.com/park';
export const PAVE_URL_NONE_REPORT_PATH = 'https://paveinspect.com/thanks';

export const _DARK_LOGO = '_DARK_LOGO';
export const DEFAULT_LOGO = 'DEFAULT_LOGO';

// COUNT TYPE
export const TYPE = {
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
};
// OS
export const OS = {
  IOS: 'IOS',
  ORTHER: 'ORTHER',
  ANDROID: 'ANDROID',
  WINDOWPHONE: 'WINDOWPHONE',
};

// SUBMIT TYPE
export const SUBMIT_TYPE = {
  DISCLOSURE: 'DISCLOSURE',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  UPDATED_DAMAGE: 'UPDATED_DAMAGE',
};

// PARTNER_SAMPLE
export const PARTNER_SAMPLE = {
  PARTNER_1_DEFAULT: 'PARTNER_1_DEFAULT',
  PARTNER_2_DDC: 'PARTNER_2_DDC',
  PARTNER_3_LANGS: 'PARTNER_3_LANGS',
  PARTNER_4: 'PARTNER_4',
};
//ALL PARTNER
export const FULL_PARTNER = {
  SCI_PARTNER: 'SCI_PARTNER',
  MUVIT_PARTNER: 'MUVIT_PARTNER',
  DEALER_PARTNER: 'DEALER_PARTNER',
  COX_USA_PARTNER: 'COX_USA_PARTNER',
  NONE_REPORT_PARTNER: 'NONE_REPORT_PARTNER',
  DEALER_TRACK_PARTNER: 'DEALER_TRACK_PARTNER',
};

// BASE_UNIT
export const BASE_ODOM_UNIT = ['MILES', 'KILOMETRES'];
export const BASE_ODOM_UNIT_FR = ['MILES', 'KILOMÈTRES'];

// DEVICE TYPE
export const DEVICE_TYPE = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  IOS: 'IOS',
  ANDROID: 'ANDROID',
};
// VIN STATUS
export const VIN_STATUS_TYPE = {
  VIN_REJECT: 'VIN_REJECT',
  VIN_RESOLVE: 'VIN_RESOLVE',
  VIN_DEFAULT: 'VIN_DEFAULT',
  VIN_CHECKING: 'VIN_CHECKING',
};
//ODOM STATUS
export const ODOM_STATUS_TYPE = {
  ODOM_DEFAULT: 'ODOM_DEFAULT',
  ODOM_RESOLVE: 'ODOM_RESOLVE',
  ODOM_CHECKING: 'ODOM_CHECKING',
  ODOM_ENTERING: 'ODOM_ENTERING',
};
// INSTRUCTION IMG
export const imgScreen1 = `${one}`;
export const imgScreen2 = `${two}`;
export const imgScreen2_uk = `${two_uk}`;
export const imgScreen2_ics = `${two_ics}`;
export const imgScreen3 = `${three}`;
export const imgScreen4 = `${four}`;
export const imgScreen5 = `${five}`;
export const imgScreen6 = `${six}`;
export const imgScreen7 = `${seven}`;
export const imgScreen8 = `${eight}`;
export const imgScreen9 = `${nine}`;
export const imgScreen10 = `${ten}`;
export const imgScreen11 = `${eleven}`;
export const imgScreen12 = `${twelve}`;
export const imgScreen13 = `${thirteen}`;
export const imgScreen15 = `${fifteen}`;

export const imgScreen10_amz = `${amz_10}`;
export const imgScreen11_amz = `${amz_11}`;
export const imgScreen12_amz = `${amz_12}`;
export const imgScreen13_amz = `${amz_13}`;

export const imgScreen04_amz = `${amz_04}`;
export const imgScreen05_amz = `${amz_05}`;
export const imgScreen07_amz = `${amz_07}`;
export const imgScreen08_amz = `${amz_08}`;

export const imgScreen_no_defined_outline = `${no_defined_outline}`;
export const searchIcon = `${search}`;
export const imageScreen = {
  1: `${one}`,
  2: `${two}`,
  '2_uk': `${two_uk}`,
  '2_ics': `${two_ics}`,
  3: `${three}`,
  4: `${four}`,
  5: `${five}`,
  6: `${six}`,
  7: `${seven}`,
  8: `${eight}`,
  9: `${nine}`,
  10: `${ten}`,
  11: `${eleven}`,
  12: `${twelve}`,
  13: `${thirteen}`,
  15: `${fifteen}`,
};

export const LITE_TYPE = {
  PAVE: 'PAVE',
  FINISH: 'FINISH',
  ADD_IMAGES: 'ADD_IMAGES',
};

export const DAMAGES_VERSION = {
  BMW: 'bmw',
  V2: 'autograde',
  V1: 'v1',
  BMW_DE: 'bmw_de',
};

export const SWITCH_MODAL = {
  WARNING: 'WARNING',
  TUTORIAL: 'TUTORIAL',
};

export const TRAFFICT_DRIVEN = 'traffic_driven';
export const pave_default_gradient =
  'linear-gradient(to bottom, #FBF9EF, #FFFFFF)';
export const pave_default_text_slider_color = '#57004E';

export const RESPONSE_TYPE = {
  REJECT: 'reject',
  TIRE: 'TIRE',
};

export const position_name = {
  VIN: 'VIN',
  INTERIOR: 'INTERIOR',
  ODOMETER: 'ODOMETER',
  LEFT_VIEW: 'DRIVER-SIDE',
  FRONT_LEFT: 'FRONT-DRIVER-QUARTER-ANGLE',
  FRONT_VIEW: 'FRONT-VIEW',
  FRONT_RIGHT: 'FRONT-PASSENGER-QUARTER-ANGLE',
  RIGHT_VIEW: 'PASSENGER-SIDE',
  REAR_RIGHT: 'REAR-PASSENGER-QUARTER-ANGLE',
  REAR_VIEW: 'REAR-VIEW',
  REAR_LEFT: 'REAR-DRIVER-QUARTER-ANGLE',
  WINDSHIELD: 'WINDSHIELD',
  TIRE: 'TIRE',
  REAR_TIRE: 'REAR_TIRE',
};

export const dataToTrans = [
  'body_type',
  'odom_unit',
  'fuel_type',
  'drivetrain',
  'engine_type',
  'transmission',
  'displacement',
  'ext_col_name',
  'int_col_name',
  'paved_ext_color.color_name',
  'paved_int_color.color_name',
];

export const langsType = {
  OBJ: 'OBJ',
  STRING: 'STRING',
};

export const transLangs = {
  EN: 'en_us',
  FR: 'fr_ca',
  MX: 'es_mx',
  BR: 'pt_br',
};

export const langsListDefault = [
  {
    iso: 'en-US',
    language_code: 'en_us',
  },
  {
    iso: 'fr-CA',
    language_code: 'fr_ca',
  },
];
export const EN_DEFAULT_ISO = 'en-US';
export const FR_DEFAULT_ISO = 'fr-CA';
export const FR_MOCK = ['FR', 'fr'];
export const EN_MOCK = ['EN', 'en'];
export const EN_DEFAULT_CODE = 'en_us';
export const FR_DEFAULT_CODE = 'fr_ca';

export const modalInitState = {
  style: {},
  title: '',
  closable: '',
  state: false,
  className: '',
  width: '520px',
  component: null,
};

export const loadingObject = {
  state: false,
  isOffline: false,
  defaultMess: <FormattedMessage {...translationsUI.PAVE_PROCESS_MESSAGE} />,
  isReceiveComponent: false,
  reportChecking: false,
};

export const defaultQuery = {
  lang: 'en',
  // theme: 'DEFAULT',
  // isContinous: true,
  // whatCode: '',
  // isReject: 'false',
  // vinDecode: 'DEFAULT',
  // odomDecode: 'DEFAULT',
  // disName: 'CA',
  // disCustom: '',
};

// DEFINE DEFAULT THEME's FLOW

//LITE
export const themeDDC = [
  {
    key: 1,
    value: null,
    defaultStatus: 'DE',
    is_retake: false,
    percent: 0,
    isCapture: true,
  },
  {
    key: 2,
    value: null,
    defaultStatus: 'DE',
    is_retake: false,
    percent: 0,
    isCapture: true,
  },
  {
    key: 3,
    value: null,
    defaultStatus: 'DE',
    is_retake: false,
    percent: 0,
    isCapture: true,
  },
];

// DEFAULT
export const defaultCapturePhotos = {
  1: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 1,
    position: position_name['VIN'],
  },
  2: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 2,
    position: position_name['INTERIOR'],
  },
  3: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 3,
    position: position_name['ODOMETER'],
  },
  4: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 4,
    position: position_name['LEFT_VIEW'],
  },
  10: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 10,
    position: position_name['FRONT_LEFT'],
  },
  5: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 5,
    position: position_name['FRONT_VIEW'],
  },
  11: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 11,
    position: position_name['FRONT_RIGHT'],
  },
  7: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 7,
    position: position_name['RIGHT_VIEW'],
  },
  12: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 12,
    position: position_name['REAR_RIGHT'],
  },
  8: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 8,
    position: position_name['REAR_VIEW'],
  },
  13: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 13,
    position: position_name['REAR_LEFT'],
  },
  9: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 9,
    position: position_name['WINDSHIELD'],
  },
  6: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 6,
    position: position_name['TIRE'],
  },
  15: {
    status: 'INQUEUE',
    passed: false,
    reason: 'MISSING',
    photoCodeUpload: 15,
    position: position_name['REAR_TIRE'],
  },
};

export const captureFlow = {
  default: [1, 2, 3, 4, 10, 5, 11, 7, 12, 8, 13, 9, 6],
  plateLeft: [8, 13, 4, 1, 2, 3, 10, 5, 11, 7, 12, 9, 6],
  plateRight: [1, 2, 3, 7, 6, 11, 5, 10, 9, 4, 13, 8, 12],
  rearTire: [1, 2, 3, 4, 10, 5, 11, 7, 12, 8, 13, 15, 9, 6],
};

export const captureFlowScreen = {
  default: [
    '1',
    '2',
    '3',
    '4',
    '10',
    '5',
    '11',
    '7',
    '12',
    '8',
    '13',
    '9',
    '6',
  ],
  plateLeft: [
    '8',
    '13',
    '4',
    '1',
    '2',
    '3',
    '10',
    '5',
    '11',
    '7',
    '12',
    '9',
    '6',
  ],
  plateRight: [
    '1',
    '2_uk',
    '3',
    '7',
    '6',
    '11',
    '5',
    '10',
    '9',
    '4',
    '13',
    '8',
    '12',
  ],
  rearTire: [
    '1',
    '2',
    '3',
    '4',
    '10',
    '5',
    '11',
    '7',
    '12',
    '8',
    '13',
    '15',
    '9',
    '6',
  ],
};

export const instructionList = {
  1: {
    key: 1,
    skip_photo_code: false,
    imgScreen: `${one}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_1} />,
    position_origin: position_name['VIN'],
  },
  2: {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${two}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  '2_rhd': {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${rhd_2}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  '2_ics': {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${two_ics}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  3: {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.DAMAGES_FORM_INPUT_1} />
    ),
    position_origin: position_name['ODOMETER'],
  },
  '3_rhd': {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.DAMAGES_FORM_INPUT_1} />
    ),
    position_origin: position_name['ODOMETER'],
  },
  4: {
    key: 4,
    skip_photo_code: false,
    imgScreen: `${four}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_LEFT} />
    ),
    position_origin: position_name['LEFT_VIEW'],
  },
  '4_rhd': {
    key: 4,
    skip_photo_code: false,
    imgScreen: `${four}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4_UK}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_RIGHT} />
    ),
    position_origin: position_name['LEFT_VIEW'],
  },
  10: {
    key: 5,
    skip_photo_code: false,
    imgScreen: `${ten}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_5} />,
    position_origin: position_name['FRONT_LEFT'],
  },
  '10_rhd': {
    key: 5,
    skip_photo_code: false,
    imgScreen: `${ten}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_7} />,
    position_origin: position_name['FRONT_LEFT'],
  },
  5: {
    key: 6,
    skip_photo_code: false,
    imgScreen: `${five}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_6}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_6} />,
    position_origin: position_name['FRONT_VIEW'],
  },
  11: {
    key: 7,
    skip_photo_code: false,
    imgScreen: `${eleven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_7} />,
    position_origin: position_name['FRONT_RIGHT'],
  },
  '11_rhd': {
    key: 7,
    skip_photo_code: false,
    imgScreen: `${eleven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_5} />,
    position_origin: position_name['FRONT_RIGHT'],
  },
  7: {
    key: 8,
    skip_photo_code: false,
    imgScreen: `${seven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_RIGHT} />
    ),
    position_origin: position_name['RIGHT_VIEW'],
  },
  '7_rhd': {
    key: 8,
    skip_photo_code: false,
    imgScreen: `${seven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8_UK}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_LEFT} />
    ),
    position_origin: position_name['RIGHT_VIEW'],
  },
  12: {
    key: 9,
    skip_photo_code: false,
    imgScreen: `${twelve}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_9} />,
    position_origin: position_name['REAR_RIGHT'],
  },
  '12_rhd': {
    key: 9,
    skip_photo_code: false,
    imgScreen: `${twelve}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_11} />,
    position_origin: position_name['REAR_RIGHT'],
  },
  8: {
    key: 10,
    skip_photo_code: false,
    imgScreen: `${eight}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_10}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_4} />
    ),
    position_origin: position_name['REAR_VIEW'],
  },
  13: {
    key: 11,
    skip_photo_code: false,
    imgScreen: `${thirteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_11} />,
    position_origin: position_name['REAR_LEFT'],
  },
  '13_rhd': {
    key: 11,
    skip_photo_code: false,
    imgScreen: `${thirteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_9} />,
    position_origin: position_name['REAR_LEFT'],
  },
  9: {
    key: 12,
    skip_photo_code: false,
    imgScreen: `${nine}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_5} />
    ),
    position_origin: position_name['WINDSHIELD'],
  },
  '9_rhd': {
    key: 12,
    skip_photo_code: false,
    imgScreen: `${rhd_9}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_5} />
    ),
    position_origin: position_name['WINDSHIELD'],
  },
  6: {
    key: 13,
    skip_photo_code: false,
    imgScreen: `${six}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_13} />,
    position_origin: position_name['TIRE'],
  },
  15: {
    key: 14,
    skip_photo_code: false,
    imgScreen: `${fifteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_15} />,
    position_origin: position_name['REAR_TIRE'],
  },
  '15_rhd': {
    key: 14,
    skip_photo_code: false,
    imgScreen: `${fifteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15_RHD}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_15} />,
    position_origin: position_name['REAR_TIRE'],
  },
};

export const instructionData = [
  {
    key: 1,
    skip_photo_code: false,
    imgScreen: `${one}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_1} />,
    position_origin: position_name['VIN'],
  },
  {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${two}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.DAMAGES_FORM_INPUT_1} />
    ),
    position_origin: position_name['ODOMETER'],
  },
  {
    key: 4,
    skip_photo_code: false,
    imgScreen: `${four}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_LEFT} />
    ),
    position_origin: position_name['LEFT_VIEW'],
  },
  {
    key: 5,
    skip_photo_code: false,
    imgScreen: `${ten}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_5} />,
    position_origin: position_name['FRONT_LEFT'],
  },
  {
    key: 6,
    skip_photo_code: false,
    imgScreen: `${five}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_6}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_6} />,
    position_origin: position_name['FRONT_VIEW'],
  },
  {
    key: 7,
    skip_photo_code: false,
    imgScreen: `${eleven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_7} />,
    position_origin: position_name['FRONT_RIGHT'],
  },
  {
    key: 8,
    skip_photo_code: false,
    imgScreen: `${seven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_RIGHT} />
    ),
    position_origin: position_name['RIGHT_VIEW'],
  },
  {
    key: 9,
    skip_photo_code: false,
    imgScreen: `${twelve}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_9} />,
    position_origin: position_name['REAR_RIGHT'],
  },
  {
    key: 10,
    skip_photo_code: false,
    imgScreen: `${eight}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_10}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_4} />
    ),
    position_origin: position_name['REAR_VIEW'],
  },
  {
    key: 11,
    skip_photo_code: false,
    imgScreen: `${thirteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_11} />,
    position_origin: position_name['REAR_LEFT'],
  },
  {
    key: 12,
    skip_photo_code: false,
    imgScreen: `${nine}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_5} />
    ),
    position_origin: position_name['WINDSHIELD'],
  },
  {
    key: 13,
    skip_photo_code: false,
    imgScreen: `${six}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_13} />,
    position_origin: position_name['TIRE'],
  },
];

export const instructionDataForHolmanClient = [
  {
    key: 1,
    skip_photo_code: false,
    imgScreen: `${one}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Locate the VIN, Serial #, or VIN Plate, and click the green camera icon to capture a photo."
      />
    ),
    position: 'Capture Photo of VIN, VIN Plate, or Serial Number',
    position_origin: position_name['VIN'],
  },
  {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${two}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Standing looking through the open driver’s door, take a photo of the interior within these lines."
      />
    ),
    position: 'INTERIOR',
    position_origin: position_name['INTERIOR'],
  },
  {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Start the vehicle and take a photo of the instrument cluster with the odometer or hours reading displayed. Before exiting the vehicle please turn the steering wheel to the left as far as it will go."
      />
    ),
    position: 'Odometer or Hours Meter',
    position_origin: position_name['ODOMETER'],
  },
  {
    key: 4,
    skip_photo_code: false,
    imgScreen: `${four}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Keeping the door closed, safely step back about 10 feet to align yourself within the left side profile. Please fit the vehicle within these lines."
      />
    ),
    position: 'Left Side',
    position_origin: position_name['LEFT_VIEW'],
  },
  {
    key: 5,
    skip_photo_code: false,
    imgScreen: `${ten}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Next, walk to the front left of the vehicle and take a front left corner shot"
      />
    ),
    position: 'Front Left Corner',
    position_origin: position_name['FRONT_LEFT'],
  },
  {
    key: 6,
    skip_photo_code: false,
    imgScreen: `${five}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Move to the front of the vehicle, stepping back safely about 10 feet, capture the vehicle’s profile to fit within these lines."
      />
    ),
    position: 'FRONT VIEW',
    position_origin: position_name['FRONT_VIEW'],
  },
  {
    key: 7,
    skip_photo_code: false,
    imgScreen: `${eleven}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Next, walk to the front right of the vehicle and take a front right corner shot"
      />
    ),
    position: 'Front Right Corner',
    position_origin: position_name['FRONT_RIGHT'],
  },
  {
    key: 8,
    skip_photo_code: false,
    imgScreen: `${seven}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Keeping the door closed, safely step back about 10 feet to align yourself within the right side profile. Please fit the vehicle within these lines."
      />
    ),
    position: 'Right Side',
    position_origin: position_name['RIGHT_VIEW'],
  },
  {
    key: 9,
    skip_photo_code: false,
    imgScreen: `${twelve}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Next, walk to the rear right of the vehicle and take a rear right corner shot"
      />
    ),
    position: 'Rear Right Corner',
    position_origin: position_name['REAR_RIGHT'],
  },
  {
    key: 10,
    skip_photo_code: false,
    imgScreen: `${eight}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Move to the rear of the vehicle and capture the vehicle’s profile to fit within these lines. "
      />
    ),
    position: 'REAR VIEW',
    position_origin: position_name['REAR_VIEW'],
  },
  {
    key: 11,
    skip_photo_code: false,
    imgScreen: `${thirteen}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Next, walk to the rear left of the vehicle and take a rear left corner shot"
      />
    ),
    position: 'Rear Left Corner',
    position_origin: position_name['REAR_LEFT'],
  },
  {
    key: 12,
    skip_photo_code: false,
    imgScreen: `${nine}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage=" Move close to the windshield and capture it within these lines."
      />
    ),
    position: 'WINDSHIELD',
    position_origin: position_name['WINDSHIELD'],
  },
  {
    key: 13,
    skip_photo_code: false,
    imgScreen: `${six}`,
    caption: (
      <FormattedMessage
        id="NULL"
        defaultMessage="Take a close up picture of one of the tires, capturing the tire tread"
      />
    ),
    position: 'TIRE',
    position_origin: position_name['TIRE'],
  },
];
export const instructionDataPlateLeft = [
  {
    key: 1,
    skip_photo_code: false,
    imgScreen: `${eight}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_10}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_4} />
    ),
    position_origin: position_name['REAR_VIEW'],
  },
  {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${thirteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_11} />,
    position_origin: position_name['REAR_LEFT'],
  },
  {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${four}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_LEFT} />
    ),
    position_origin: position_name['LEFT_VIEW'],
  },
  {
    key: 4,
    skip_photo_code: false,
    imgScreen: `${one}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_1} />,
    position_origin: position_name['VIN'],
  },
  {
    key: 5,
    skip_photo_code: false,
    imgScreen: `${two}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  {
    key: 6,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.DAMAGES_FORM_INPUT_1} />
    ),
    position_origin: position_name['ODOMETER'],
  },
  {
    key: 7,
    skip_photo_code: false,
    imgScreen: `${ten}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_5} />,
    position_origin: position_name['FRONT_LEFT'],
  },
  {
    key: 8,
    skip_photo_code: false,
    imgScreen: `${five}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_6}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_6} />,
    position_origin: position_name['FRONT_VIEW'],
  },
  {
    key: 9,
    skip_photo_code: false,
    imgScreen: `${eleven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_7} />,
    position_origin: position_name['FRONT_RIGHT'],
  },
  {
    key: 10,
    skip_photo_code: false,
    imgScreen: `${seven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_RIGHT} />
    ),
    position_origin: position_name['RIGHT_VIEW'],
  },
  {
    key: 11,
    skip_photo_code: false,
    imgScreen: `${twelve}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_9} />,
    position_origin: position_name['REAR_RIGHT'],
  },
  {
    key: 12,
    skip_photo_code: false,
    imgScreen: `${nine}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_5} />
    ),
    position_origin: position_name['WINDSHIELD'],
  },
  {
    key: 13,
    skip_photo_code: false,
    imgScreen: `${six}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_13} />,
    position_origin: position_name['TIRE'],
  },
  {
    key: 14,
    skip_photo_code: false,
    imgScreen: `${fifteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_15} />,
    position_origin: position_name['REAR_TIRE'],
  },
];

export const instructionDataPlateRight = [
  {
    key: 1,
    skip_photo_code: false,
    imgScreen: `${one}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_1} />,
    position_origin: position_name['VIN'],
  },
  {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${two_uk}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.DAMAGES_FORM_INPUT_1} />
    ),
    position_origin: position_name['ODOMETER'],
  },
  {
    key: 4,
    skip_photo_code: false,
    imgScreen: `${seven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_LEFT} />
    ),
    position_origin: position_name['RIGHT_VIEW'],
  },
  {
    key: 5,
    skip_photo_code: false,
    imgScreen: `${six}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_13} />,
    position_origin: position_name['TIRE'],
  },
  {
    key: 6,
    skip_photo_code: false,
    imgScreen: `${eleven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_5} />,
    position_origin: position_name['FRONT_RIGHT'],
  },
  {
    key: 7,
    skip_photo_code: false,
    imgScreen: `${five}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_6}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_6} />,
    position_origin: position_name['FRONT_VIEW'],
  },
  {
    key: 8,
    skip_photo_code: false,
    imgScreen: `${ten}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_7} />,
    position_origin: position_name['FRONT_LEFT'],
  },
  {
    key: 9,
    skip_photo_code: false,
    imgScreen: `${nine}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_5} />
    ),
    position_origin: position_name['WINDSHIELD'],
  },
  {
    key: 10,
    skip_photo_code: false,
    imgScreen: `${four}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4_UK}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_RIGHT} />
    ),
    position_origin: position_name['LEFT_VIEW'],
  },
  {
    key: 11,
    skip_photo_code: false,
    imgScreen: `${thirteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_9} />,
    position_origin: position_name['REAR_LEFT'],
  },
  {
    key: 12,
    skip_photo_code: false,
    imgScreen: `${eight}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_10}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_4} />
    ),
    position_origin: position_name['REAR_VIEW'],
  },
  {
    key: 13,
    skip_photo_code: false,
    imgScreen: `${twelve}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9_UK}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_11} />,
    position_origin: position_name['REAR_RIGHT'],
  },
  {
    key: 14,
    skip_photo_code: false,
    imgScreen: `${fifteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_15} />,
    position_origin: position_name['REAR_TIRE'],
  },
];

export const instructionDataRearTire = [
  {
    key: 1,
    skip_photo_code: false,
    imgScreen: `${one}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_1} />,
    position_origin: position_name['VIN'],
  },
  {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${two}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.DAMAGES_FORM_INPUT_1} />
    ),
    position_origin: position_name['ODOMETER'],
  },
  {
    key: 4,
    skip_photo_code: false,
    imgScreen: `${four}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_LEFT} />
    ),
    position_origin: position_name['LEFT_VIEW'],
  },
  {
    key: 5,
    skip_photo_code: false,
    imgScreen: `${ten}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_5} />,
    position_origin: position_name['FRONT_LEFT'],
  },
  {
    key: 6,
    skip_photo_code: false,
    imgScreen: `${five}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_6}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_6} />,
    position_origin: position_name['FRONT_VIEW'],
  },
  {
    key: 7,
    skip_photo_code: false,
    imgScreen: `${eleven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_7} />,
    position_origin: position_name['FRONT_RIGHT'],
  },
  {
    key: 8,
    skip_photo_code: false,
    imgScreen: `${seven}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.ADD_DAMAGES_VIEW_RIGHT} />
    ),
    position_origin: position_name['RIGHT_VIEW'],
  },
  {
    key: 9,
    skip_photo_code: false,
    imgScreen: `${twelve}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_9} />,
    position_origin: position_name['REAR_RIGHT'],
  },
  {
    key: 10,
    skip_photo_code: false,
    imgScreen: `${eight}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_10}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_4} />
    ),
    position_origin: position_name['REAR_VIEW'],
  },
  {
    key: 11,
    skip_photo_code: false,
    imgScreen: `${thirteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_11} />,
    position_origin: position_name['REAR_LEFT'],
  },
  {
    key: 12,
    skip_photo_code: false,
    imgScreen: `${fifteen}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_15} />,
    position_origin: position_name['REAR_TIRE'],
  },
  {
    key: 13,
    skip_photo_code: false,
    imgScreen: `${nine}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE_5} />
    ),
    position_origin: position_name['WINDSHIELD'],
  },
  {
    key: 14,
    skip_photo_code: false,
    imgScreen: `${six}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_13} />,
    position_origin: position_name['TIRE'],
  },
];

export const instructionDataLite = [
  {
    key: 1,
    skip_photo_code: false,
    imgScreen: `${one}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1}
      />
    ),
    position: <FormattedMessage {...translationsComponents.LABEL_1} />,
    position_origin: position_name['VIN'],
  },
  {
    key: 2,
    skip_photo_code: false,
    imgScreen: `${two}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.PAVE_DAMS_GROUP_TITLE} />
    ),
    position_origin: position_name['INTERIOR'],
  },
  {
    key: 3,
    skip_photo_code: false,
    imgScreen: `${three}`,
    caption: (
      <FormattedMessage
        {...translationsComponents.CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3_LITE}
      />
    ),
    position: (
      <FormattedMessage {...translationsComponents.DAMAGES_FORM_INPUT_1} />
    ),
    position_origin: position_name['ODOMETER'],
  },
];

export const disclosuresType = {
  CAN: 'CA',
  USA: 'US',
};
export const announcementsType = {
  CUSTOM: 'CUSTOM',
  DEFAULT: 'DEFAULT',
};

export const VEHICLE_DECODE = 'Vehicle not yet decoded';
export const FINISH_INSPECTION = 'finished';
export const PROCESS_INSPECTION = 'inspecting';
export const INVALID_WARNING = 'invalid_warning';

export const NETWORK_STATUS = {
  NONE: 'NONE',
  WEAK: 'WEAK',
  ONLINE: 'ONLINE',
  ORTHER: 'ORTHER',
  OFFLINE: 'OFFLINE',
  JUST_ONLINE: 'JUST_ONLINE',
  JUST_OFFLINE: 'JUST_OFFLINE',
};

export const SETTING_DAMAGE_COMPONENTS = {
  TIRE_FRONT_LEFT: {
    EN: 'TIRE_FRONT_LEFT',
    FR: 'PNEU_AVANT_GAUCHE',
    VI: 'LỐP_XE_TRƯỚC_TRÁI',
  },
  TIRE_REAR_LEFT: {
    EN: 'TIRE_REAR_LEFT',
    FR: 'PNEU_ARRIÈRE_CÔTÉ_GAUCHE',
    VI: 'LỐP_XE_SAU_TRÁI',
  },
  TIRE_FRONT_RIGHT: {
    EN: 'TIRE_FRONT_RIGHT',
    FR: 'PNEU_AVANT_CÔTÉ_DROIT',
    VI: 'LỐP_XE_TRƯỚC_PHẢI',
  },
  TIRE_REAR_RIGHT: {
    EN: 'TIRE_REAR_RIGHT',
    FR: 'PNEU_ARRIÈRE_CÔTÉ_DROIT',
    VI: 'LỐP_XE_SAU_PHẢI',
  },
  GOOD_CONDITION: {
    EN: 'GOOD_CONDITION',
    FR: 'BON_ÉTAT',
    VI: 'TỐT',
  },
  WORN_MEDIUM: {
    EN: 'WORN_MEDIUM',
    FR: 'USURE_MOYENNE',
    VI: 'MÒN_TRUNG_BÌNH',
  },
  WORN_MAJOR: {
    EN: 'WORN_MAJOR',
    FR: 'USURE_MAJEURE',
    VI: 'MÒN_NẶNG',
  },
  LIKE_NEW: {
    EN: 'LIKE_NEW',
    FR: 'COMME_NEUF',
    VI: 'NHƯ_MỚI',
  },
  WINTER_TREAD: {
    EN: 'WINTER_TREAD',
    FR: 'PNEU_HIVER',
    VI: 'LỐP_MÙA_ĐÔNG',
  },
  BULGED: {
    EN: 'BULGED',
    FR: 'RENFLÉ',
    VI: 'PHỒNG_LỐP',
  },
  WEATHER_CRACKED: {
    EN: 'WEATHER_CRACKED',
    FR: 'TEMPS_CRAQUÉ',
    VI: 'NỨT_DO_THỜI_TIẾT',
  },
  MISSMATCH_TIRE: {
    EN: 'MISSMATCH_TIRE',
    FR: 'PNEU DÉPAREILLÉ',
    VI: 'LỐP_KHÔNG_TRÙNG_KHỚP',
  },
  FLAT_TIRE: {
    EN: 'FLAT_TIRE',
    FR: 'PNEU_À_PLAT',
    VI: 'XẸP_HƠI',
  },
};

export const INFO_TYPE = {
  BODY_TYPE: 'body_type',
  FUEL_TYPE: 'fuel_type',
  OMDOM_UNIT: 'odom_unit',
  DRIVETRAIN: 'drivetrain',
  ENGINE_TYPE: 'engine_type',
  TRANSMISSION: 'transmission',
  OMDOM_READING: 'odom_reading',
  PAVE_EXT_COLOR: 'paved_ext_color',
  PAVE_INT_COLOR: 'paved_int_color',
  DISPLACEMENT_TYPE: 'displacement',
};
export const IMG_COLLECTION_STATUS = {
  UP: 'UP',
  AC: 'AC',
  DE: 'DE',
};
export const MobileVendor = {
  Huawei: 'Huawei',
  Apple: 'Apple',
};
export const COMMON_RESOLUTION = {
  DEFAULT: 'DEFAULT',
  TWO_K: 'TWO_K',
  FOUR_K: 'FOUR_K',
};

export const FILE_TYPE = {
  PNG: 'png',
  JPEG: 'jpeg',
  WEBP: 'webp',
};
export const resolutionSetting = [
  {
    key: 'default_jpeg',
    label: 'FHD',
    content: '1920x1080-jpeg',
    preset: {
      resolution: COMMON_RESOLUTION['DEFAULT'],
      type: FILE_TYPE['JPEG'],
      name: 'default_jpeg',
    },
  },
  {
    key: '4k_jpeg',
    label: '4K',
    content: '3840x2160-jpeg',
    preset: {
      resolution: COMMON_RESOLUTION['FOUR_K'],
      type: FILE_TYPE['JPEG'],
      name: '4k_jpeg',
    },
  },
];

export const cameraConstraints = {
  width: 1920,
  height: 1080,
  facingMode: 'environment',
};

export const cameraConstraints2K = {
  width: {
    min: 1280,
    ideal: 2048,
    max: 3840,
  },
  height: {
    min: 720,
    ideal: 1080,
    max: 2160,
  },
  facingMode: 'environment',
};

export const cameraConstraints4K = {
  width: {
    min: 1920,
    ideal: 3840,
    max: 3840,
  },
  height: {
    min: 1080,
    ideal: 2160,
    max: 2160,
  },
  facingMode: 'environment',
};

export const odomSample_en = [
  {
    key: 'KI',
    value: 'Kilometres',
  },
  {
    key: 'MI',
    value: 'Miles',
  },
];
export const odomSample_fr = [
  {
    key: 'KI',
    value: 'Kilomètres',
  },
  {
    key: 'MI',
    value: 'Miles',
  },
];
export const odomTypes = {
  INPUT_ODOM: 'U1',
  INPUT_UNIT: 'U2',
};

export const secondsCountDown = 5;
export const actionUpload = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
};
export const actionStopCountDown = {
  LOADER: 'LOADER',
  REVIEW: 'REVIEW',
};

export const decodeFrom = {
  CAM: 'CAM',
  ORTHER: 'ORTHER',
};
export const envSwitch = {
  DEV: 'DEV',
  PRODUCTION: 'PRODUCTION',
};

export const themeActions = {
  PAVE_DDE: 'DDE',
  PAVE_DSD: 'DSD',
  PAVE_TCU: 'TCU',
  PAVE_AAT: 'TDT',
  PAVE_CDE: 'CDE',
  PAVE_UAD: 'UAD',
  PAVE_DDC: 'LITE',
  PAVE_UAC: 'UAC',
  PAVE_CDD_CODE: 'CDD',
  PAVE_INSPECT: 'INSPECT',
  PAVE_CAPT: 'CAPT',
  PAVE_DEFAULT: 'DEFAULT',
  PAVE_PASS: 'PAVE-PASS',
  PAVE_PLATE_LEFT: 'PLATE-LEFT',
  PAVE_PLATE_RIGHT: 'PLATE-RIGHT',
  PAVE_REAR_TIRE: 'REAR-TIRE',
};
export const validSession = {
  NONE: 'NONE',
  VALID: 'VALID',
  INVALID: 'INVALID',
};

export const sessionIDRegex = /[A-Z0-9]{3,4}-[A-Z0-9]{10}/gm;
export const base64regex =
  /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

export const regexDispute =
  /^\/dispute\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const breakPoint = {
  sm: 568,
  md: 920,
  lg: 1200,
};
export const fakeDataOffline = {
  photos: {
    missing: [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '15',
    ],
    rejected: [],
  },
};

export const optionsBranch = {
  bmw: 'bmw',
};

export const PHOTOS_STATUS = {
  REJECTED: 'REJECTED',
  MISSING: 'MISSING',
  FINISH: 'FINISH',
  UPLOADING: 'UPLOADING',
};

export const errorMessCamera = `Your camera is not active.`;
// export const errorMessCamera = `Your camera doesn't active.
// Please open the Settings app, then tap on Safari > Camera,
// then scroll down to Camera & Microphone, confirm that "Ask" or "Allow" is checked,
// Retry the "Refresh the call" steps, above.`;

export const SPECIAL_POSITION_VIEWS = {
  10: 'FRONT-DRIVER-QUARTER-ANGLE', // FRONT_LEFT
  11: 'FRONT-PASSENGER-QUARTER-ANGLE', // FRONT_RIGHT
  12: 'REAR-PASSENGER-QUARTER-ANGLE', // REAR_RIGHT
  13: 'REAR-DRIVER-QUARTER-ANGLE', // REAR_LEFT
};

// Create a reverse map
const REVERSE_SPECIAL_POSITION_VIEWS = Object.keys(
  SPECIAL_POSITION_VIEWS
).reduce((acc, key) => {
  acc[SPECIAL_POSITION_VIEWS[key]] = Number(key);
  return acc;
}, {});

const getPositionCode = (positionName) => {
  return REVERSE_SPECIAL_POSITION_VIEWS[positionName] || 'Unknown position';
};

export const createUrl = (positionView, cageBranding, options) => {
  const convertedPhotoCode = getPositionCode(positionView);

  const { make = false, model = false } = options;

  let srcURL = '';
  let defaultSrcURL = '';

  const srcURLRam = `${REACT_APP_PAVE_CAGES_CDN}/static/pave_cage_data_static/ram_promaster_${convertedPhotoCode}.svg`;

  if ((!make || !model) && cageBranding === 'amazon') {
    srcURL = `${REACT_APP_PAVE_CAGES_CDN}/static/pave_cage_data_static/ram_promaster_${convertedPhotoCode}.svg`;
    defaultSrcURL = srcURL;
    return { srcURL, defaultSrcURL };
  }

  if (cageBranding === 'amazon') {
    defaultSrcURL = srcURLRam;

    const retryURLs = convertMakeModel({ make, model }).map((item) => {
      return `${REACT_APP_PAVE_CAGES_CDN}/static/pave_cage_data_static/${item}_${convertedPhotoCode}.svg`;
    });

    return { srcURL: retryURLs[0], defaultSrcURL, retryURLs: retryURLs };
  } else {
    srcURL = `${REACT_APP_PAVE_CAGES_CDN}/static/pave_cage_data_static/hyundai_tucson_${convertedPhotoCode}.svg`;
    defaultSrcURL = srcURL;
    return { srcURL, defaultSrcURL };
  }
};

function convertMakeModel(item) {
  const make = item.make.toLowerCase();
  const modelWords = item.model
    .replace(/258\/268|238\/258\/268/, 'edge')
    .replace('/', ' ')
    .split(' ');


  let expected1 = `${make}_${modelWords[0].replace('-', '')}`.toLowerCase();

  let expected2 = `${make}_${modelWords[0].toLowerCase()}`;
  if (modelWords.length > 1) {
    expected2 += `_${modelWords[1].toLowerCase()}`;
  } else {
    expected2 = null;
  }

  // Special case for E-Series
  if (item.model === 'E-Series') {
    expected1 = 'ford_E-Series';
    expected2 = null;
  }

  return [expected1, expected2];
}
